import { useEffect, useRef, type ReactNode } from "react"

// The slot for the thin bars above Console's pages: scheduled maintenance
// first, then a release announcement under it when one is running. Each bar
// shows or closes on its own; this only stacks them.
//
// Tells pages sized to the screen (100vh, h-screen) how tall the stack is,
// via --top-bar-height, so they shrink by it and Console doesn't scroll. It's
// 0 when no bar shows, and follows the stack as bars close or text wraps.
export function TopBars({ children }: { children: ReactNode }) {
  const slotRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const root = document.documentElement
    const slot = slotRef.current
    if (!slot) return
    const update = () =>
      root.style.setProperty("--top-bar-height", `${slot.offsetHeight}px`)
    update()
    const observer = new ResizeObserver(update)
    observer.observe(slot)
    return () => {
      observer.disconnect()
      root.style.setProperty("--top-bar-height", "0px")
    }
  }, [])

  return <div ref={slotRef}>{children}</div>
}
